import raf from 'raf';

const resizeIframe = (iframe, height) => {
  iframe.height = height;
};

const HEIGHT_THRESHOLD = 100;
const MIN_HEIGHT = 600;
const EXTRA_HEIGHT = 60;

const calculateHeight = (iframe) => {
  let height = 0;

  // In some cases we get cross-origin access errors
  // when external postings have iFrames inside our iFrame
  try {
    height = Math.max(
      iframe.contentWindow.document.body.scrollHeight,
      iframe.contentWindow.document.documentElement.scrollHeight
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  } finally {
    // Setting a minimal height for iFrames that might not get loaded quick enough
    height = height < HEIGHT_THRESHOLD ? MIN_HEIGHT : height + EXTRA_HEIGHT;
  }

  return height;
};

export const onIframeLoad = (iframeRef) =>
  raf(() => {
    const { current: iframe } = iframeRef;
    const height = calculateHeight(iframe);
    resizeIframe(iframe, height);
  });
